<script>
import { onMounted,ref } from 'vue'
import FormItem from './form-item.vue'
import {isNotEmpty} from '@/tools/utils';
export default {
  name: 'piece-base-form',
  components: { FormItem },
  props:['formSet','isShowBlock','showRow'],
  computed:{
    showBody(){
      if(isNotEmpty(this.isShowBlock) && !this.isShowBlock){
        let body = this.formSet.data.body.filter((item,index)=>{
          let numerData = isNotEmpty(this.showRow) ? this.showRow*1 : 1;
          let itemNum = 3*numerData
          return  index<itemNum
        });
        return body
      }else{
        return this.formSet.data.body
      }
    }
  },
  inject: ['baseData'],
  methods:{
    showItem(items){
      if(isNotEmpty(this.isShowBlock) && !this.isShowBlock){
        return items.filter((item,index)=>{
          let numerData = isNotEmpty(this.showRow) ? this.showRow*1 : 1;
          let itemNum = 3*numerData
          return  index<itemNum
        });
      }else{
        return items
      }
    }
  },
}
</script>
<template>
  <div>
    <q-form class="my-form">
      <div v-for="(body,index) in formSet.data.body" :key="body.index+index">
        <div class="row p10" style="padding-bottom: 0px;padding-top: 0px">
          <div class="col-4 p5" v-for="item in showItem(body.items)" :key="item.name">
            <span class="my-form-item">
              <div class="my-form-item-label" :style="{width:item.labelWidth+'px'}" v-if="item.showlabel"><span v-if="item.required" class="text-pink">*</span>{{item.label}}</div>
              <q-skeleton type="QInput" :style="{marginLeft:item.labelWidth+'px'}" :width= "'180px'" :height="item.skeletonHeight || '24px'" v-if="formSet.data.loading"/>
              <form-item :style="{marginLeft:item.labelWidth+'px'}" style="display: inline-block" :form-item="item" :title="item.value" v-else></form-item>
            </span>
          </div>
        </div>
      </div>
    </q-form>
  </div>
</template>
<style lang="scss" scoped>
.my-form{
  .my-form-item{
    position: relative;
  }
  .my-form-item-label{
    position: absolute;
    display: inline-block;
    text-align: end;
    padding-right: 5px;
  }
}
.p10{
  padding:10px ;
}
.p5{
  padding: 5px;
}
.pb10{
  padding-bottom: 10px;
}
.form-box {
  white-space:nowrap;
  margin-right: 15px;
  width: 290px;
}
.form-box-doubling{
  width: 603px;
}
.second-form {
  .form-box {
    &:nth-last-child(2) {
      width: 300px;
    }
  }
}
::v-deep .q-field--dense .q-field__control {
  min-width: 180px;

}
::v-deep .q-tab-panel {
  padding: 0;
}
</style>

